import React from "react";
import PropTypes from "prop-types";
import { useCuvetteTooltip } from "./CuvetteTooltip.utils";
import { ControlButtons, ControlTooltip } from "../../../ControlTooltip";

export function CuvetteTooltip(props) {
  const { getButtonList } = useCuvetteTooltip(props);

  const buttionList = getButtonList();
  if (props.showControls && buttionList.length) {
    return (
      <ControlTooltip showControls tooltipStyle={{ top: "-55px" }}>
        <ControlButtons buttonList={getButtonList()} />
      </ControlTooltip>
    );
  } else return null;
}

CuvetteTooltip.propTypes = {
  /**
   * UniqueId for the lid covering the Cuvette
   */
  lidId: PropTypes.number,
  /**
   * Boolean set to shwo control icons
   */
  showControls: PropTypes.bool,
  /**
   * Color value for the solution [ Empty means no solution]
   */
  solution: PropTypes.string,
  /**
   * function to remove an Item
   */
  onRemoveItem: PropTypes.func,
};

CuvetteTooltip.defaultProps = {
  showControls: false,
};
